import {
    Typography, Paper, Box,
    Divider,
    IconButton,
    Tooltip,
    Stack,
    Button,
    Menu,
    MenuItem,
  } from '@mui/material';
import { memo, useCallback, useEffect, useState } from 'react';
import { Add, ArrowBack, ArrowForward, Article, Book, Brightness1, ChevronLeft, DarkMode, Download, LightMode, MenuBook, MoreVert, Pageview, Palette, Print, Save, SmartToy } from '@mui/icons-material';
import Page from '../interfaces/page';

interface PagesTabProps{
  mode: number;
  pages: Page[],
  currentPageIndex: number,
  setCurrentPageIndex: React.Dispatch<React.SetStateAction<number>>;
}

function PagesTab ({ mode, pages, currentPageIndex, setCurrentPageIndex }: PagesTabProps) {
  const [isLeftSidebarCollapsed, setIsLeftSidebarCollapsed] = useState(false);


  const handleToggleLeftSidebar = useCallback(() => {
    setIsLeftSidebarCollapsed(!isLeftSidebarCollapsed);
  }, [isLeftSidebarCollapsed]);


  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: "100%",
        paddingX: 1,
        flexShrink: 1,
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        minWidth: '50px',
        width: isLeftSidebarCollapsed ? '25px' : '100%',
        maxWidth: '20%'
      }}
    >
      <Tooltip title={isLeftSidebarCollapsed ? 'Expand Pages' : 'Collapse Pages'}>
        <IconButton sx={{ width: 'fit-content', color: mode === 0 ? "white" : "#121212" }} onClick={handleToggleLeftSidebar}>
          {isLeftSidebarCollapsed ? <ArrowForward/> : <ArrowBack/>}
        </IconButton>
      </Tooltip>

      {!isLeftSidebarCollapsed && (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: 'Roboto, sans-serif',
                color: mode === 0 ? "white" : "#121212"
              }}
            >
              Note Pages
            </Typography>

            {/* <IconButton
              onClick={addNewPage}
              sx={{ color: mode === 0 ? "white" : "#121212" }}
            >
              <Add />
            </IconButton> */}
          </Box>

          <Box 
            sx={{ 
              overflowY: 'auto',
              mt: 2,
              flexGrow: 1,
            }}
          >
            {pages.map((page, index) => {
              const isActive = currentPageIndex === page.id;

              return (
                <Box
                  key={page.id}
                  sx={{
                    padding: 1,
                    marginBottom: 1,
                    cursor: 'pointer',
                    backgroundColor: isActive ? (mode === 1 ? '#8276f5' : 'grey.500') : 'transparent',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    '&:hover': {
                      backgroundColor: isActive ? '#e8f0fe' : (mode === 1 ? '#e8f0fe' : `grey.700`),
                    },
                  }}
                  onClick={() => {
                    setCurrentPageIndex(page.id);
                  }}
                >
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{
                      flexGrow: 1,
                      color: isActive ? "inherit" : (mode === 1 ? 'inherit' : 'white'),
                      fontWeight: isActive ? 500 : 400,
                    }}
                  >
                    {page.title || `Untitled Page ${index + 1}`}
                  </Typography>

                  <IconButton
                    size="small"
                    // onClick={(e) => handleMenuOpen(e, index)}
                    sx={{ opacity: 0.7 }}
                  >
                    <MoreVert fontSize="small" />
                  </IconButton>

                </Box>
              );
            })}
          </Box>
        </Box>
      )}

    </Box>
  );
};

export default memo(PagesTab);